<template>
  <div>
    <template v-if="isMobileLogin">
      <div class="container">
    <div class="row flex-column justify-content-start align-items-center" style="height: 100vh; margin-top: 20px;">
      <div
        class="col-md-6 h-100 img-login"
        :style="`background-image: url('https://bucketrecreativa.s3.amazonaws.com/coruja.png')`"
      ></div>
      <div
        class="col-md-6 col-sm-12 d-flex flex-column justify-content-center align-items-center"
      >
        <div class="card" >
          <Input title="Login" v-model="user.login" />
          <Input title="Senha" type="password" v-model="user.password" />
          <button @click="login" class="btn-login">Entrar</button>
        </div>
        
        <span class="label mt-5 fs-12"
          >Esqueceu a senha?
          <a
            @click="$router.push({ path: '/esqueci-senha' })"
            style="color: #8d4d9a"
            ><b>Recuperar</b></a
          ></span
        >
        
        <span class="label mt-5"
          >NÃO TEM UMA CONTA?
          <a
            @click="$router.push({ path: '/assinatura/planos' })"
            href=""
            style="color: #8d4d9a"
            ><b> CADASTRE-SE</b></a
          ></span
        >

        <!-- <div class="containerProviderLogin">
          <button @click="loginWithGoogle" class="buttonLoginWithGoogle">Login com google</button>
        </div> -->
        

        <div class="containerProviderLogin" style="width: 60%">
          <button @click="loginWithGoogle" class="buttonLoginWithGoogle">
             <img width="20px"  alt="Google sign-in" 
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png" />
                <span style="margin-left:5px;">Login com Google
                  </span> 
                </button>
        </div>
        
        <div class="containerProviderLogin" style="width: 60%">
          <button @click="loginWithFacebook" class="buttonLoginWithGoogle">
             <img width="20px"  alt="Google sign-in" 
                src="https://www.flaticon.com/svg/static/icons/svg/145/145802.svg" />
                <span style="margin-left:5px;">Login com Facebook
                  </span> 
                </button>
        </div>

      </div>
    </div>
    <!-- <Alert text="VEJA AS NOVIDADES!" />
    <SliderBottom /> -->
  </div>
    </template>
        <template v-else>
      <div>
    <Alert
      text="PLANO GRATUITO"
      callbackText="ASSINAR"
      :callback="() => $router.push({ path: '/assinatura/planos' })"
      :plan="true"
      :backButton="true"
      :isGame="false"
    />
    <div class="row" style="height: 95vh">
      <div
        class="col-md-6 h-100 img-login"
        :style="`background-image: url('https://bucketrecreativa.s3.amazonaws.com/coruja.png')`"
      ></div>
      <div
        class="col-md-6 col-sm-12 d-flex flex-column justify-content-center align-items-center"
      >
        <div class="card" style="width: 65%">
          <Input title="Login" v-model="user.login" />
          <Input title="Senha" type="password" v-model="user.password" />
          <button @click="login" class="btn-login">Entrar</button>
        </div>
        
        <span class="label mt-5 fs-12"
          >Esqueceu a senha?
          <a
            @click="$router.push({ path: '/esqueci-senha' })"
            style="color: #8d4d9a"
            ><b>Recuperar</b></a
          ></span
        >
        
        <span class="label mt-5"
          >NÃO TEM UMA CONTA?
          <a
            @click="$router.push({ path: '/assinatura/planos' })"
            href=""
            style="color: #8d4d9a"
            ><b> CADASTRE-SE</b></a
          ></span
        >

        <!-- <div class="containerProviderLogin">
          <button @click="loginWithGoogle" class="buttonLoginWithGoogle">Login com google</button>
        </div> -->
        

        <div class="containerProviderLogin" style="width: 60%">
          <button @click="loginWithGoogle" class="buttonLoginWithGoogle">
             <img width="20px"  alt="Google sign-in" 
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png" />
                <span style="margin-left:5px;">Login com Google
                  </span> 
                </button>
        </div>
        
        <div class="containerProviderLogin" style="width: 60%">
          <button @click="loginWithFacebook" class="buttonLoginWithGoogle">
             <img width="20px"  alt="Google sign-in" 
                src="https://www.flaticon.com/svg/static/icons/svg/145/145802.svg" />
                <span style="margin-left:5px;">Login com Facebook
                  </span> 
                </button>
        </div>

      </div>
    </div>
    <!-- <Alert text="VEJA AS NOVIDADES!" />
    <SliderBottom /> -->
  </div>
    </template>
  </div>
</template>

<script>
import { validator } from "../assets/js/util";
import Input from "../components/Input";
import decode from "jwt-decode";
import Alert from "../components/AlertaPlano";
// import SliderBottom from "../components/SliderBottom";
import firebase from 'firebase'

export default {
  name: "Login",
  components: {
    Input,
    Alert,
    // SliderBottom,
  },
  data: () => ({
    user: {
      login: "",
      password: "",
    },
    isMobileLogin: false,
    plans: {}
  }),
  mounted(){
    //this.$store.commit("jogo", false);
    console.log("isMobile",this.$store.getters.isMobile)
        this.isMobileLogin = this.$store.getters.isMobile;

      //    var x = window.innerWidth;
      //    console.log("x", x)
      // if (x < 800) {
      //   this.isMobileLogin= true;
      // }
  },
  methods: {
    login: function () {
      this.$store.commit("loading", true);
      if (this.user.login != "" && this.user.password != "") {
        if (validator("email", this.user.login)) {
          this.$axios
            .post("login", this.user)
            .then((res) => res.data)
            .then((res) => {
              localStorage.setItem("t", JSON.stringify(res.token));
              this.$store.commit("logado", true);
              //this.firebaseAnalytic(this.user.login, this.user.password);
              this.$store.commit("setStateModal", {
                visible: true,
                title: "Bem vindo!",
                type: "success",
                message: `Olá ${
                  decode(res.token).usr.name
                }, é um prazer te-lo novamente conosco, aproveite o site e tenha uma ótima jogatina.`,
              });
              this.saveTypeUser();
              this.$store.commit("loading", false);
              this.$router.replace({ path: "/" });
            })
            .catch((e) => {
              this.$store.commit("loading", false);
              this.$store.commit("setStateModal", {
                visible: true,
                title: "ATENÇÃO",
                type: "warning",
                message: e.response.data.message,
              });
            });
        } else {
          this.$store.commit("loading", false);
          this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message: "Verifique se o e-mail digitado é válido.",
          });
        }
      } else {
        this.$store.commit("loading", false);
        this.$store.commit("setStateModal", {
          visible: true,
          title: "ATENÇÃO",
          type: "warning",
          message: "Verifique se o campos foram digitados corretamente.",
        });
      }
      
      

    },
    loginUserOfProvider: function(email, password, displayName){
      console.log("ENTROU EM LOGIN GOOGLE")
      this.$store.commit("loading", true);
      this.user.login = email;
      this.user.password = password;
        this.$axios
          .post("login", this.user)
          .then((res) => res.data)
          .then((res) => {    
            localStorage.setItem("t", JSON.stringify(res.token));
            this.$store.commit("logado", true);
            this.$store.commit("setStateModal", {
              visible: true,
              title: "Bem vindo!",
              type: "success",
              message: `Olá ${
                decode(res.token).usr.name
              }, é um prazer te-lo novamente conosco, aproveite o site e tenha uma ótima jogatina.`,
            });
            this.saveTypeUser();
            this.$store.commit("loading", false);
            this.$router.replace({ path: "/" });
          })
          .catch((e) => {
            console.log(e, "error")
            this.$store.commit("loading", false);
            this.registerUserOfProvider(email, password, displayName);
            // this.$store.commit("setStateModal", {
            //   visible: true,
            //   title: "ATENÇÃO",
            //   type: "warning",
            //   message: "Usu",
            // });
          });
    },
    registerUserOfProvider: async function(email, password, displayName){
      console.log("ENTROU EM REGISTERGOOGLE")
      this.$store.commit("loading", true);
      let user = {
        email,
        password
      };
        //user.planos_id = this.$store.getters.getItemInCart.payload.id;
        user.planos_id = 4;  // Força o usuario ao plano gratuito
        //////////  adicionando dados ao usuario para cadastro
        var brokenName = displayName.split(" ");
        user.name = brokenName[0];
        if(brokenName[1]){
          user.sobrenome = brokenName[1]
        }else{
          user.sobrenome = ""
        }
      
      await this.$axios
        .post("https://api2.arecreativa.com.br/create_customer", {
          name: user.name + " " + user.sobrenome,
          email: this.user.login.trim(),
        })
        .then((res) => {
          user.stripe_id = res.data.id;

          this.$axios
            .post(`register`, user)
            .then((res) => res.data)
            .then(async (res) => {
              localStorage.setItem("t", JSON.stringify(res.token));
              this.saveTypeUser();
              await this.$store.commit("loading", false);           
                await setTimeout(async () => {
                  await this.$store.commit("logado", true);
                }, 1000)        
              await this.$router.replace({ path: "/" });
            }).catch(async e => {
                console.log("ERRO AO CADASTRAR GOOGLE", e)
                this.$store.commit("loading", false);
                this.$store.commit("setStateModal", {
                  visible: true,
                  title: e.response.data.message,
                  type: "warning",
                  message: "Este email ja tem uma conta cadastrada!"
                });
            })
        }).catch(async e => {
            console.log("ERRO AO CADASTRAR GOOGLE", e)
            this.$store.commit("loading", false);
            this.$store.commit("setStateModal", {
              visible: true,
              title: e.response.data.message,
              type: "warning",
              message: "Este email ja tem uma conta cadastrada!"
            });
        })
    },
    loginWithGoogle: async function(){
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().useDeviceLanguage();
      let self = this;

      await firebase.auth().signInWithPopup(provider).then(function(result) {
            var user = result.user;
            console.log("RESULTADO LOGIN GOOGLE")
            console.log(result)
            self.loginUserOfProvider(user.email, user.uid, user.displayName)
          }).catch(function(error) {
            // var email = error.email;
            // // The firebase.auth.AuthCredential type that was used.ß
            alert("O email da sua conta do Google ja está sendo utilizado em uma conta cadastrada!")
            console.log("LOGIN GOOGLE ERROR")
            console.log(error)
          });

        this.user.login = ""
        this.user.password = ""
    },
    
    loginUserOfProviderFacebook: function(email, password, displayName){
      console.log("ENTROU EM LOGIN FACEBOOK")
      this.$store.commit("loading", true);
      this.user.login = email;
      this.user.password = password;
        this.$axios
          .post("login", this.user)
          .then((res) => res.data)
          .then((res) => {    
            localStorage.setItem("t", JSON.stringify(res.token));
            this.$store.commit("logado", true);
            this.$store.commit("setStateModal", {
              visible: true,
              title: "Bem vindo!",
              type: "success",
              message: `Olá ${
                decode(res.token).usr.name
              }, é um prazer te-lo novamente conosco, aproveite o site e tenha uma ótima jogatina.`,
            });
            this.$store.commit("loading", false);
            this.$router.replace({ path: "/" });
          })
          .catch((e) => {
            console.log(e, "error")
            this.$store.commit("loading", false);
            this.registerUserOfProviderFacebook(email, password, displayName);

          });
    },
    registerUserOfProviderFacebook: async function(email, password, displayName){
      console.log("ENTROU EM REGISTER FACEBOOK")
      this.$store.commit("loading", true);
      let user = {
        email,
        password
      };
        //user.planos_id = this.$store.getters.getItemInCart.payload.id;
        user.planos_id = 4;  // Força o usuario ao plano gratuito
        //////////  adicionando dados ao usuario para cadastro
        var brokenName = displayName.split(" ");
        user.name = brokenName[0];
        if(brokenName[1]){
          user.sobrenome = brokenName[1]
        }else{
          user.sobrenome = ""
        }
      
      await this.$axios
        .post("https://api2.arecreativa.com.br/create_customer", {
          name: user.name + " " + user.sobrenome,
          email: this.user.login.trim(),
        })
        .then((res) => {
          user.stripe_id = res.data.id;

          console.log("O user que chegou até aqui")
          console.log(user)
          console.log("User.email")
          console.log(user.email)

          this.$axios
            .post(`register`, user)
            .then((res) => res.data)
            .then(async (res) => {
              localStorage.setItem("t", JSON.stringify(res.token));
              await this.$store.commit("loading", false);           
                await setTimeout(async () => {
                  await this.$store.commit("logado", true);
                }, 1000)        
              await this.$router.replace({ path: "/" });
            }).catch(async e => {
                console.log("ERRO AO CADASTRAR FACEBOOK", e)
                this.$store.commit("loading", false);
                this.$store.commit("setStateModal", {
                  visible: true,
                  title: e.response.data.message,
                  type: "warning",
                  message: "Este email ja tem uma conta cadastrada!"
                });
            })
        }).catch(async e => {
            console.log("ERRO AO CADASTRAR FACEBOOK", e)
            this.$store.commit("loading", false);
            this.$store.commit("setStateModal", {
              visible: true,
              title: e.response.data.message,
              type: "warning",
              message: "Este email ja tem uma conta cadastrada!"
            });
        })
    },
    loginWithFacebook: async function(){
      var provider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().useDeviceLanguage();
      let self = this;

      await firebase.auth().signInWithPopup(provider).then(function(result) {
            var user = result.user;
            console.log("RESULTADO LOGIN GOOGLE")
            console.log(result)
            self.loginUserOfProviderFacebook(user.email, user.uid, user.displayName)
          }).catch(function(error) {
            // var email = error.email;
            // // The firebase.auth.AuthCredential type that was used.ß
            alert("O email da sua conta do Facebook ja está sendo utilizado em uma conta cadastrada!")
            console.log("LOGIN FACEBOOK ERROR")
            console.log(error)
          });

        this.user.login = ""
        this.user.password = ""
    },

    getFreePlan: async function(){
      this.$store.commit("loading", true);
      await this.$axios
        .get(`/jogo/planos`)
        .then((res) => res.data)
        .then((res) => {
          this.$store.commit("loading", false);
          localStorage.removeItem("abriuPagamento"); 
          this.setPlan(res[0])
          // if(typeof(res)==='object'){
          //   this.plans = Object.entries(res).map(el => el[1])
          // }else{
          //   this.plans = res;
          // }
        });
    },
    setPlan: async function (plan) {
      await this.$store.commit("loading", true)
      await this.$store.commit("addItemInCart", {
        type: "plan",
        payload: plan,
      });
      console.log("esse é o plano")
      console.log(plan);
      // await this.$router.push({ path: "/assinatura/cadastro" });
      await this.$store.commit("loading", false)
    },
    saveTypeUser: async function () {
      this.$axios
          .get(
            `users/${decode(localStorage.getItem("t")).usr.id}`
          )
          .then((res) => res.data)
          .then((res) => {
            localStorage.setItem("typeOfUser", JSON.parse(res[0].tipo));
          })
          .catch((err) => {
            console.log("Erro ao salvar tipo de usuario", err)
          });
    },
  },
};
</script>

<style scoped>
.container {
  overflow: auto;
  height: 100%;
}
.card {
  border: none;
  padding: 30px 40px;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  font-size: 14px !important;
  position: relative;
  width: 65%;
}

.img-login {
  background-size: cover;
}

.btn-login {
  width: 100%;
  height: 50px;
  bottom: -25px;
  left: 0;
  border: none;
  font-size: 18px;
  background-color: #8d4d9a;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  position: absolute;
  text-transform: uppercase;
  transition: ease 0.5s;
}

.containerProviderLogin{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.buttonLoginWithGoogle{
      display: flex;
      justify-content:center;
      align-items: center;
      background: white;
      color: #444;
      width: 100%;
      border: thin solid #888;
      box-shadow: 1px 1px 1px grey;
      white-space: nowrap;
      height: 50px;

}

.btn-login:hover {
  transform: scale(1.05);
}

.label {
  font-size: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
}
@media screen and (max-height: 900px){
  .buttonLoginWithGoogle{
      height: 30px;
}
}
@media screen and (max-width: 900px){
  .card{
  border: none;
  padding: 30px 40px;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  font-size: 16px !important;
  position: relative;
  width: 100%;
  scroll-behavior: auto;
}
}
</style>